<template>
    <div :class="classNamesElement">
        <label :for="id">
            <translate>{{ label }}</translate>
        </label>
        <select class="form-input select" :name="id" :id="id"
                @change="$emit('update:modelValue', $event.target.value)" ref="input"
                :required="required" :autofocus="autofocus" :autocomplete="autocomplete" :disabled="disabled">
            <option v-for="option in computedOptions" :value="option.value" :selected="option.selected" :key="option.id">{{ option.option }}</option>
        </select>
        <span v-if="errorOrInfo" class="form-info">{{ errorOrInfo }}</span>
    </div>
</template>

<script>
export default {
    name: 'FormSelect',
    props: [
        'modelValue',
        'id',
        'type',
        'label',
        'required',
        'autofocus',
        'autocomplete',
        'error',
        'info',
        'disabled',
        'options',
    ],
    computed: {
        computedOptions() {
            let comutedOptions = [
                {
                    value: '', option: this.$gettext('Bitte auswählen'),
                },
            ];

            if (this?.options[0]?.country_name) {
                this.options.map(item => {
                    comutedOptions.push({value: item.id, option: item.country_name, selected: parseInt(this.modelValue) === item.id});
                });
            }

            if (this?.options[0]?.language_name) {
                this.options.map(item => {
                    comutedOptions.push({value: item.id, option: this.$gettext(item.language_name), selected: this.modelValue === item.id});
                });
            }

            if (this?.options[0]?.iso_value) {
                this.options.map(item => {
                    comutedOptions.push({value: item.iso_value, option: this.$gettext(item.iso_name), selected: this.modelValue === item.iso_value});
                });
            }

            if (this?.options[0]?.value) {
                this.options.map(item => {
                    comutedOptions.push({value: item.value, option: item.text, selected: String(this.modelValue) === String(item.value)});
                });
            }
            return comutedOptions;
        },
        classNamesElement() {
            let classNames = ['form-element'];
            if (this.error) classNames.push('form-element--error');
            if (!this.error && this.modelValue) classNames.push('form-element--valid');
            if (this.modelValue) classNames.push('form-element--filled');

            return classNames;
        },
        errorOrInfo() {
            return this.error ? this.error : this.info;
        },
    },
    emits: ['update:modelValue'],
    methods: {
        focus() {
            this.$refs.input.focus();
        }
    }
};
</script>
